module.exports = __webpack_public_path__ + "static/img/Q_preview.9f0af733.png";